module.exports = __webpack_public_path__ + "img/rockport.3ca9022b.png";